// extracted by mini-css-extract-plugin
export default {"services":"service_services__7mUaY"};